module.exports = __webpack_public_path__ + "img/map_1791458177135_55000.580af8ff.jpg";